module.exports = {
  lang: {
    t1: `Accueil`,
    t2: `Carte de visite`,
    t3: `Suivre`,
    t4: `Contacts`,
    t5: `Messages`,
    t6: `Connexion`,
    t7: `S'inscrire`,
    t8: `Nouvelle plate-forme mondiale de connectivité commerciale, nouveau territoire pour le marketing numérique des entreprises`,
    t9: `WeMeet - Connexion avec le numéro de téléphone`,
    t10: `Numéro de téléphone mobile`,
    t11: `Code de vérification`,
    t12: `Veuillez entrer votre numéro de téléphone mobile`,
    t13: `Veuillez entrer le code de vérification`,
    t14: `Obtenir`,
    t15: `Connexion`,
    t16: `Veuillez entrer le numéro de téléphone mobile au format correct`,
    t17: `Code de vérification envoyé`,
    t18: `Code de vérification incorrect saisi. Veuillez vérifier et ressaisir.`,
    t19: `Connexion réussie`,
    t20: `Votre code de vérification est (0). Veuillez l'utiliser dans les {1} minute(s).`,
    t21: `Annuler`,
    t22: `Confirmer`,
    t23: `Conseils utiles`,
    t24: `Votre inscription au compte WeMeet n'est pas encore terminée. Agissez dès maintenant pour finaliser le processus d'enregistrement et profiter d'interactions variées et de possibilités illimitées.`,
    t25: `Aller à l'inscription`,
    t26: `Connexion courriel WeMeet`,
    t27: `Nom du compte`,
    t28: `Entrez votre adresse e-mail`,
    t29: `Mot de passe`,
    t30: `Entrez votre mot de passe`,
    t31: `Mot de passe oublié ?`,
    t32: `Se connecter`,
    t33: `Autres méthodes de connexion`,
    t34: `Déjà enregistré pour l'application WeMeet Mini ? Utilisez-la maintenant.`,
    t35: `Se connecter avec un numéro de téléphone`,
    t36: `Veuillez saisir votre adresse e-mail d'abord.`,
    t37: `Veuillez saisir votre mot de passe d'abord.`,
    t38: `Le format de l'adresse e-mail est incorrect`,
    t39: `Si vous avez déjà un compte WeMeet, vous pouvez vous connecter directement`,
    t40: `Se connecter`,
    t41: `Photo de profil`,
    t42: `Veuillez téléverser une photo de profil réelle`,
    t43: `Nom complet`,
    t44: `Prénom`,
    t45: `Nom de famille`,
    t46: `Nom de l'organisation`,
    t47: `Veuillez saisir le nom de votre organisation`,
    t48: `Poste`,
    t49: `Veuillez saisir le titre de votre poste au sein de l'organisation`,
    t50: `E-mail`,
    t51: `Entrez votre adresse e-mail`,
    t52: `Numéro de téléphone mobile`,
    t53: `Veuillez entrer votre numéro de téléphone mobile`,
    t54: `Région`,
    t55: `Veuillez sélectionner une région`,
    t56: `Zone`,
    t57: `Veuillez sélectionner la province, la ville et le district`,
    t58: `Adresse`,
    t59: `Veuillez saisir votre adresse`,
    t60: `J'ai lu et j'accepte les`,
    t61: `Conditions d'utilisation`,
    t62: `Politique de confidentialité`,
    t63: `Continuer`,
    t64: `Veuillez d'abord cocher l'accord utilisateur`,
    t65: `Veuillez saisir votre nom`,
    t66: `Veuillez remplir votre nom de famille`,
    t67: `Veuillez d'abord remplir votre adresse e-mail`,
    t68: `Veuillez d'abord remplir le nom de votre organisation`,
    t69: `Le format de l'adresse e-mail est incorrect`,
    t70: `Annuler`,
    t71: `Compléter`,
    t72: `Vérifier le numéro de portable`,
    t73: `Numéro de téléphone mobile`,
    t74: `Code de vérification`,
    t75: `Veuillez entrer le code de vérification`,
    t76: `Obtenir`,
    t77: `Ignorer la vérification`,
    t78: `Soumettre`,
    t79: `Vérifié`,
    t80: `Code de vérification incorrect saisi. Veuillez vérifier et ressaisir.`,
    t81: `Ignoré`,
    t82: `Conseils utiles`,
    t83: `Le numéro de téléphone que vous avez saisi est déjà enregistré avec un compte WeMeet. Pas besoin de vous réinscrire, veuillez vous connecter dès maintenant.`,
    t84: `Aller à la connexion`,
    t85: `Conseils utiles`,
    t86: `L'adresse e-mail que vous avez saisie est déjà enregistrée avec un compte WeMeet. Pas besoin de vous réinscrire, veuillez vous connecter dès maintenant.`,
    t87: `Aller à la connexion`,
    t88: `Un lien de vérification a été envoyé.`,
    t89: `Veuillez vérifier votre boîte de réception et cliquer sur le lien pour finaliser l'enregistrement.`,
    t90: `Compris`,
    t91: `Bienvenue chez WeMeet`,
    t92: `Bienvenue chez WeMeet ! Veuillez cliquer sur le bouton pour finaliser votre inscription. Avis amical : Ce lien est valide pendant 24 heures, veuillez procéder rapidement.`,
    t93: `S'inscrire`,
    t94: `Votre e-mail a été activé. Veuillez saisir votre mot de passe.`,
    t95: `Saisissez votre mot de passe`,
    t96: `Entrez votre mot de passe`,
    t97: `Confirmez votre mot de passe`,
    t98: `Veuillez saisir à nouveau votre mot de passe`,
    t99: `Doit contenir une combinaison de lettres majuscules et minuscules, de chiffres et de caractères spéciaux, d'une longueur comprise entre 8 et 20 caractères`,
    t100: `Entrez votre mot de passe`,
    t101: `Veuillez saisir à nouveau votre mot de passe`,
    t102: `Les mots de passe ne correspondent pas`,
    t103: `Félicitations pour avoir achevé votre enregistrement`,
    t104: `Vous êtes désormais connecté·e à WeMeet. Vous pouvez poursuivre vos opérations précédentes.`,
    t105: `Poursuivez votre expérience`,
    t106: `Conseils utiles`,
    t107: `Le lien a expiré. Veuillez cliquer sur le bouton pour le récupérer à nouveau.`,
    t108: `Renvoyer`,
    t109: `Conditions d'utilisation`,
    t110: `Politique de confidentialité`,
    t111: `Récupérer le mot de passe`,
    t112: `Veuillez saisir le compte pour lequel vous souhaitez récupérer le mot de passe`,
    t113: `Nom du compte`,
    t114: `Entrez votre adresse e-mail`,
    t115: `Soumettre`,
    t116: `Veuillez saisir votre adresse e-mail d'abord.`,
    t117: `Le format de l'adresse e-mail est incorrect`,
    t118: `Courriel envoyé`,
    t119: `Veuillez vérifier votre boîte de réception, cliquer sur le lien et réinitialiser votre mot de passe.`,
    t120: `Compris`,
    t121: `Réinitialisation de mot de passe - WeMeet`,
    t122: `Votre demande de réinitialisation de mot de passe a été confirmée, et le système a généré un lien temporaire de réinitialisation de mot de passe. Avis amical : Ce lien est valide pendant 24 heures, veuillez procéder rapidement.`,
    t123: `Réinitialiser le mot de passe`,
    t124: `Réinitialisation de mot de passe réussie`,
    t125: `Vous êtes connecté à WeMeet. Bienvenue de retour.`,
    t126: `Aller à l'accueil`,
    t127: `Contacts`,
    t128: `Nouvelle demande de contact`,
    t129: `Accepter`,
    t130: `Ignorer`,
    t131: `Approuvé(e)`,
    t132: `Ignoré(e)`,
    t133: `Suivant`,
    t134: `Suivi(e)`,
    t135: `Messages`,
    t136: `Demande en attente`,
    t137: `Veuillez saisir votre nom ou votre numéro de téléphone`,
    t138: `Aucun contenu correspondant trouvé`,
    t139: `Plus rien d'autre`,
    t140: `Demande de contact`,
    t141: `Accepter`,
    t142: `Ignorer`,
    t143: `Approuvé(e)`,
    t144: `Ignoré(e)`,
    t145: `Espace WeMeet AI`,
    t146: `Abonné(e)`,
    t147: `Désabonné(e)`,
    t148: `vCard`,
    t149: `Connecter`,
    t150: `Envoyer un message`,
    t151: `En attente d'approbation`,
    t152: `Retirer un contact`,
    t153: `Présentation personnelle`,
    t154: `Profil personnel`,
    t155: `Conseils utiles`,
    t156: `Votre demande de contact a bien été envoyée. Une fois approuvée, vous commencerez automatiquement à suivre TA. Vous pouvez également choisir de le suivre dès maintenant pour en savoir plus sur lui.`,
    t157: `Ne pas suivre pour l'instant`,
    t158: `Suivre`,
    t159: `Abonné(e)`,
    t160: `Supprimer la relation de contact`,
    t161: `Après avoir supprimé la relation de contact, l'autre personne ne pourra plus consulter vos informations personnelles, mais elle ne vous désabonnera pas automatiquement.`,
    t162: `Repensez-y`,
    t163: `Retirer un contact`,
    t164: `Opération réussie`,
    t165: `Assistant IA WeMeet`,
    t166: `Saisissez votre question`,
    t167: `Envoyer`,
    t168: `Veuillez noter que le contenu d'interaction avec l'IA peut être inexact et ne reflète pas le point de vue de la plateforme.`,
    t169: `Carte de visite WeMeet`,
    t170: `Télécharger`,
    t171: `Modifier la carte de visite`,
    t172: `Télécharger le code QR`,
    t173: `L'image a été générée. Veuillez la sauvegarder. Scannez le code QR pour enregistrer le contact.`,
    t174: `Photo de profil`,
    t175: `Veuillez téléverser une photo de profil réelle`,
    t176: `Nom complet`,
    t177: `Prénom`,
    t178: `Nom de famille`,
    t179: `Saisissez votre nom`,
    t180: `Nom de l'organisation`,
    t181: `Veuillez saisir le nom de votre organisation`,
    t182: `Poste`,
    t183: `Veuillez saisir le titre de votre poste au sein de l'organisation`,
    t184: `E-mail`,
    t185: `Entrez votre adresse e-mail`,
    t186: `Numéro de téléphone mobile`,
    t187: `Veuillez entrer votre numéro de téléphone mobile`,
    t188: `Région`,
    t189: `Veuillez sélectionner une région`,
    t190: `Zone`,
    t191: `Veuillez sélectionner la province, la ville et le district`,
    t192: `Adresse`,
    t193: `Veuillez saisir votre adresse`,
    t194: `Veuillez saisir votre nom`,
    t195: `Veuillez remplir votre nom de famille`,
    t196: `Veuillez d'abord remplir votre adresse e-mail`,
    t197: `Veuillez d'abord remplir le nom de votre organisation`,
    t198: `Le format de l'adresse e-mail est incorrect`,
    t199: `Salon de discussion`,
    t200: `Galerie de photos`,
    t201: `Prendre une photo`,
    t202: `Saisissez votre message`,
    t203: `Envoyer`,
    t204: `Lu`,
    t205: `Non lu`,
    t206: `Délai de retrait expiré`,
    t207: `Annuler`,
    t208: `Photo`,
    t209: `Album`,
    t210: `Photographier`,
    t211: `Sélectionner depuis l'album`,
    t212: `Annuler`,
    t213: `Photo`,
    t214: `Portrait`,
    t215: `Aperçu`,
    t216: `Compléter`,
    t217: `Espace WeMeet AI`,
    t218: `Contactez-nous`,
    t219: `Contactez-moi`,
    t220: `Nom complet`,
    t221: `Organisation`,
    t222: `Poste`,
    t223: `Téléphone`,
    t224: `E-mail`,
    t225: `Région`,
    t226: `Zone`,
    t227: `Adresse`,
    t228: `Veuillez saisir votre nom`,
    t229: `Veuillez remplir le nom de votre organisation`,
    t230: `Veuillez remplir votre poste`,
    t231: `Veuillez saisir votre numéro de téléphone`,
    t232: `Veuillez remplir votre adresse e-mail`,
    t233: `Veuillez sélectionner une région`,
    t234: `Veuillez sélectionner la province, la ville et le district`,
    t235: `Veuillez entrer une adresse`,
    t236: `Intention`,
    t237: `Acheter des produits`,
    t238: `Produits d'agent`,
    t239: `Coopération sur le marché`,
    t240: `Autre`,
    t241: `Veuillez saisir votre nom`,
    t242: `Veuillez remplir le nom de votre organisation`,
    t243: `Veuillez remplir votre adresse e-mail`,
    t244: `Le format de l'adresse e-mail est incorrect`,
    t245: `Message soumis`,
    t246: `Laisser un message`,
    t247: `Veuillez saisir le contenu de votre demande`,
    t248: `Confirmer`,
    t249: `Veuillez vous connecter ou vous inscrire d'abord`,
    t250: `Abonnés`,
    t251: `Nous contacter`,
    t252: `Produits`,
    t253: `Équipe`,
    t254: `Présentation générale`,
    t255: `Album`,
    t256: `Qualification`,
    t257: `Capital social`,
    t258: `Date de fondation`,
    t259: `Adresse enregistrée`,
    t260: `Amont`,
    t261: `Milieu cours`,
    t262: `Aval`,
    t263: `Связанные отрасли`,
    t264: `Procédé`,
    t265: `Sauvegarder`,
    t266: `Vérifié`,
    t267: `Chinois`,
    t268: `Anglais`,
    t269: `Français`,
    t270: `Russe`,
    t271: `Espagnol`,
    t272: `Japonais`,
    t273: `Coréen`,
    t274: `Indonésien`,
    t275: `Vietnamien`,
    t276: `Allemand`,
    t277: `Turc`,
    t278: `Italien`,
    t279: `Portugais`,
    t280: `Thaï`,
    t281: `Malais`,
    t282: `Arabe`,
    t283: `Nom d'utilisateur ou mot de passe incorrect`,
    t284: `Veuillez lire et accepter les Conditions d'utilisation de WeMeet avant de continuer`,
    t285: `Aucun contenu pertinent disponible`,
    t286: `Type`,
    t287: `Attribut`,
    t288: `Détails`,
    t289: `Autre`,
    t290: `Total de 2 produits`,
    t291: `{1} vous invite à visiter le WeMeet AI Space de {2}`,
    t292: `Cliquez ici pour un exemple ou entrez une question :`,
    t293: `Rafraîchir`,
    t294: `Vous pouvez également cliquer sur la carte de visite ci-dessous pour ajouter des contacts pour plus d'informations :`,
    t295: `Apprendre`,
    t296: `Réunions numériques WeMeet`,
    t297: `Expositions numériques WeMeet`,
    t298: `WeMeet Personal Card and WeMeet AI Space`,
    t299: `Comment devenir membre d'une organisation WeMeet`,
    t300: `WeMeet Service de Conférence Numérique vous fournit une solution complète pour les réunions en ligne, comprenant entre autres la création et la publication de réunions, la gestion des inscriptions des participants, le check-in électronique, la planification des réunions, le partage de documents, les discussions interactives en temps réel et les interactions avec les invités.`,
    t301: `WeMeet Exposition Numérique, aidant à construire rapidement un micro-site web officiel d'exposition. Afficher les informations des exposants, les présentations des expositions, les diffusions en direct des expositions, l'inscription à l'exposition, les horaires des événements, et plus encore, permettant aux entreprises participantes et au public de comprendre facilement les détails de l'exposition. Pour utiliser la fonction WeMeet Exposition Numérique, veuillez d'abord compléter le processus d'entrée institutionnelle. Cliquez sur "Mon", faites défiler jusqu'à "Centre de Services" - "Entrée Institutionnelle" et suivez les instructions pour compléter le processus d'entrée.`,
    t302: `Les utilisateurs personnels de WeMeet n'ont qu'à autoriser leur ID WeChat, leur numéro de téléphone et compléter l'inscription à la plateforme pour obtenir une carte de visite numérique personnelle et maintenir leur Lounge AI personnel (incluant le CV personnel, les mises à jour, les photos, les documents, etc.).`,
    t303: `Cliquez sur l'option "Moi" dans la barre de menu inférieure du mini-programme pour mettre à jour la page de la carte de visite personnelle et améliorer la page d'accueil personnelle.`,
    t304: `Combinaison de lettres majuscules et minuscules, de chiffres et de signes de ponctuation, d'une longueur comprise entre 8 et 20 caractères.`,
    t305: `Entrer le nom du produit`,
    t306: `Plus d'articles`,
    t307: `Cliquez sur le coin supérieur droit`,
    t308: `Sélectionnez votre moyen de partage préféré`,
    t309: `J'ai compris`,
    t310: `Veuillez d'abord vous inscrire et vous connecter`,
    t311: `En savoir plus`,
    t312: `Produits associés`,
    t313: `Merci de votre visite`,
    t314: `Déconnexion`,
    t315: `Organisation suivie`,
    t316: `Précédent`,
    t317: `Suivant`,
    t318: `Aucun`,
    t319: `{1} vous invite à visiter {2}`,
    t320: `Le salon AI n'a pas maintenu la langue actuelle`,
    t321: `Le salon AI a basculé vers la langue actuelle`,
    t322: `Le lien a été activé`,
    t323: `Le réseau est occupé, veuillez réessayer plus tard`,
    t324: `Les détails du produit ont été basculés dans la langue actuelle`,
    t325: `Les détails du produit ne sont pas actuellement maintenus dans cette langue`,
    t326: `Bonjour, je suis l'assistant AI intelligent de WeMeet, prêt à vous fournir un service attentionné à tout moment ! Comment puis-je vous aider ?`,
    t327: `Entrez le nom`,
    t328: `J'ai trouvé les informations de contact pertinentes, veuillez vérifier la carte de contact ci-dessous.`,
    t329: `Pièce jointe`,
    t330: `Je n'ai pas trouvé les informations de contact pertinentes.`,
    t331: `J'ai transféré votre demande au collègue responsable ci-dessous ; vous pouvez également cliquer sur la carte de visite pour contacter immédiatement.`,
    t332: `Exposition`,
    t333: `Veuillez entrer`,
    t334: `Utilisateur`,
    t335: `Plus d'articles`,
    t336: `Actualisation réussie`,
    t337: `Chargement`,
    t338: `Libérer pour actualiser`,
  },
};
